import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Spinner from "../../../spinner";
import Swal from "sweetalert2";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import TermsCheckbox from "./TermsCheckbox";
import "./index.css";
import { configuration } from "../../../appConfig";
import Axios from "axios";
import { FormGroup, Label } from "reactstrap";
import { profile_logo_base64 } from "./profileDefaultlogo";
import ReactSelect from "react-select";
import { connect } from "react-redux";
import { toggleDamageImages } from "../../../redux/actions/showReportDamageImage";
import { compose } from "redux";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

const INITIAL_STATE = {
  email: "",
  company_name: "",
  website_url: "",
  address: "",
  // partner_id: localStorage.getItem("partnerId"),
  primary_contact: "",
  company_registration_no: "",
  primary_color: "#0384C8",
  secondary_color: "#1E84C8",
  primary_text_color: "#000000",
  secondary_text_color: "#F7F3F3",
  table_footer_color: "#000000",
  logo_image: "",
  alu: "",
  lak: "",
  glu: "",
  bodyWork: "",
  printed_form: "",
  authorizer_name: "",
  badge_number: "",
  PricePerHour: "",
  basePrice: "",
  error: null,
  termCheckboxToggle: false,
  isSpinnerToggle: false,
  showAlert: false,
  words: {},
  drive_name: "1",
  lang: "",
  carDetails: [],
  is_email: false,
  svgPartNumber: false,
  is_email_authorized: false,
  is_dat: false,
  extendedImageViewlabel: false,
  isEmailAuthorizedModel: false,
  isDatModel: false,
  showRomDocument: false,
  damageImageToggle: false,
  showDamageToggle: false,
  dentShowingToggle: false,
  dentEditorRemoveX: false,
  showReplaceColumn: false,
  showExtraPage: false,
  isPasswordModalOpen: false,
  password: '',
  toggleType: '',
  passwordError: null,
  isEmailAuthorized: false,
  isDatAuthorized: false,
  partnerId: [],
  partnerIdOptions: [],
  clientBasedOptions: [],
  selectedpartnerId: [],
  is_vin_duplicate : false
};

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

export class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };

    this.togglePasswordModal = this.togglePasswordModal.bind(this);
    this.validatePasswordAndToggle = this.validatePasswordAndToggle.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
  }

  componentDidMount() {
    this.setState({ showAlert: true });
    this.getFallbackDetails();
    this.getLang(); 
    setTimeout(() => {
      this.getPartnerIdOptions();
    }, 1000);
  }

  getPartnerIdOptions = async () => {
    const client = localStorage.getItem("client");
    const storedPartnerId = localStorage.getItem("partnerId");
    const { allPartnerId } = this.props;

    const filterPartnerId = allPartnerId && Array.isArray(allPartnerId) && allPartnerId.length > 0
      ? allPartnerId.filter(id => id.client.split("_")[0] === client)
      : [];

    const getPartnerId = filterPartnerId && filterPartnerId.length > 0
      ? filterPartnerId
        .filter(id => id.partnerId !== storedPartnerId)
        .map(id => ({ value: id.partnerId, label: id.partnerId }))
      : [];

    this.setState({ clientBasedOptions: getPartnerId });
  };

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };
  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };
  handleChangeEmail = (e) => {
    const isEmail = e.target.checked;
    this.setState({
      is_email: isEmail,
    });
  };

  handlePriceChange = (e, typeOfPrice) => {
    const { carDetails } = this.state;
    const { name, value } = e.target;
    const updatedCarDetails = [...carDetails];

    const indexToUpdate = updatedCarDetails.findIndex(o => o.CarType === name && parseInt(o.priceType) === parseInt(typeOfPrice));

    if (indexToUpdate !== -1) {
      updatedCarDetails[indexToUpdate] = {
        ...updatedCarDetails[indexToUpdate],
        price: value
      };
    } else {
      updatedCarDetails.push({
        CarType: name,
        priceType: typeOfPrice == 0 ? "" : typeOfPrice,
        price: value,
      });
    }

    this.setState({
      carDetails: updatedCarDetails
    });
  }

  onLogoImageSelect = (event) => {
    if (event.target.files.length) {
      let src = URL.createObjectURL(event.target.files[0]);
      this.logo_img_ref.style.backgroundImage = `url(${src})`;
      this.logo_img_ref.style.backgroundSize = `contain`;
      this.logo_img_ref.style.backgroundRepeat = `no-repeat`;
      this.logo_img_ref.style.backgroundPosition = `center`;
      this.logo_img_ref.innerHTML = "";

      // To convert local image into base64
      File.prototype.convertToBase64 = function (callback) {
        var reader = new FileReader();
        reader.onloadend = function (e) {
          callback(e.target.result, e.target.error);
        };
        reader.readAsDataURL(this);
      };
      var selectedFile = event.target.files[0];
      selectedFile.convertToBase64((base64) => {
        this.setState({ logo_image: base64 });
      });
    }
  };

  getFallbackDetails = async () => {
    const client = localStorage.getItem('client');
    const partner_id = (localStorage.getItem('partnerId_new') !== 'null' && localStorage.getItem('partnerId_new')) ? localStorage.getItem('partnerId_new') : localStorage.getItem('partnerId');
    // const partner_id = localStorage.getItem('partnerId_new') || localStorage.getItem('partnerId');
    this.setState({
      partner_id
    })
    const url =
      configuration.getFallbackDetails +
      `?partner_id=${partner_id}`;
    const res = await Axios.get(url);

    if (res.data.success !== false) {
      let company_logo =
        configuration.getFallbackLogoPath +
        localStorage.getItem("partnerId") +
        "/" +
        res.data.company_logo;


      this.setState({
        logo_image: res.data.company_logo_base64 || profile_logo_base64,
        email: res.data.company_email || "",
        company_name: res.data.company_name || "",
        website_url: res.data.company_website || "",
        address: res.data.company_address || "",
        primary_color: res.data.primary_color || "#0384C8",
        secondary_color: res.data.secondary_color || "#1E84C8",
        primary_text_color: res.data.primary_text_color || "#000000",
        secondary_text_color: res.data.secondary_text_color || "#F7F3F3",
        table_footer_color: res.data.table_footer_color || "#000000",
        primary_contact: res.data.contact_number || "",
        alu: res.data.alu || "",
        lak: res.data.lak || "",
        glu: res.data.glu || "",
        bodyWork: res.data.WR || "",
        printed_form: res.data.printed_form || "",
        authorizer_name: res.data.authorizer_name || "",
        badge_number: res.data.badge_number || "",
        company_registration_no: res.data.company_registration_number || "",
        PricePerHour: res.data.PricePerHour || "",
        basePrice: res.data.basePrice || "",
        drive_name: res.data.drive_through,
        carDetails: res.data.carDetails,
        is_email: res.data.is_email == 1 ? true : false || "",
        svgPartNumber: res.data.svg_part_number == 1 ? true : false,
        is_email_authorized: res.data.is_email_authorized == 1 ? true : false || "",
        is_dat: res.data.is_dat == 1 ? true : false || "",
        extendedImageViewlabel: res.data.extended_view == 1 ? true : false,
        showRomDocument: res.data.is_document_show == 1 ? true : false,
        damageImageToggle: res.data.is_default_damage_image == 1 ? true : false,
        showDamageToggle: res.data.is_damage_image == 1 ? true : false,
        dentShowingToggle: res.data.dent_showing == 1 ? true : false,
        dentEditorRemoveX: res.data.is_remove_x == 1 ? true : false,
        showReplaceColumn: res.data.is_show_replace_column == 1 ? true : false,
        is_vin_duplicate : res.data.is_vin_duplicate == 1 ? true : false
      });
      if (res.data.vin_duplicate_partner_id && res.data.vin_duplicate_partner_id.length > 0) {
        const newOptions = res.data.vin_duplicate_partner_id.map((val) => ({
          label: val,
          value: val
        }));

        this.setState((prevState) => ({
          partnerIdOptions: [...prevState.partnerIdOptions, ...newOptions],
          selectedpartnerId : res.data.vin_duplicate_partner_id
        }));
      }
      this.props.toggleDamageImages(res.data.is_default_damage_image == 1 ? true : false);
      if (client == "ROM") {
        localStorage.setItem("showDocumentExtraImage", res.data.is_document_show)
      }

      if (res.data.is_email === 0 || res.data.is_email === "0") {
        localStorage.setItem("isSendEmail", "no");
      } else {
        localStorage.setItem("isSendEmail", "yes");
      }

      if (res.data.company_logo && res.data.company_logo != "../adi.jpg" && res.data.company_logo_base64 != "") {
        this.logo_img_ref.style.backgroundImage = `url(${company_logo})`;
        this.logo_img_ref.style.backgroundSize = `contain`;
        this.logo_img_ref.style.backgroundRepeat = `no-repeat`;
        this.logo_img_ref.style.backgroundPosition = `center`;
        this.logo_img_ref.innerHTML = "";

      } else {
        this.logo_img_ref.style.backgroundImage = `url(https://driveandscan.de/adi.jpg)`;
        this.logo_img_ref.style.backgroundSize = `contain`;
        this.logo_img_ref.style.backgroundRepeat = `no-repeat`;
        this.logo_img_ref.style.backgroundPosition = `center`;
        this.logo_img_ref.innerHTML = "";
      }
    }
  };
  handleSvgPartChange = (e) => {
    this.setState({ svgPartNumber: e.target.checked })
  }
  handleExtendImageView = (e) => {
    this.setState({ extendedImageViewlabel: e.target.checked })
  }
  handleDamageToggle = (e) => {
    const showReportDamageImages = e.target.checked;
    this.setState({ damageImageToggle: e.target.checked })
    this.props.toggleDamageImages(showReportDamageImages)
  }
  handleDentShowingToggle = (e) => {
    this.setState({ dentShowingToggle: e.target.checked })
  }
  handleDentRemovexToggle = (e) => {
    this.setState({ dentEditorRemoveX: e.target.checked })
  }
  handleShowReplaceColumnToggle = (e) => {
    this.setState({ showReplaceColumn: e.target.checked })
  }
  // handleEmailAuthorize = (e) => {
  //   console.log('handleEmailAuthorize :>> ', e.target.checked);
  //   this.setState({ isEmailAuthorizedModel: e.target.checked })
  // }
  // handleDATCredentials = (e) => {
  //   console.log('handleDATCredentials :>> ', e.target.checked);
  //   this.setState({ isDatModel: e.target.checked })
  // }

  handleRomDocumentShow = (e) => {
    this.setState({ showRomDocument: e.target.checked })
  }

  togglePasswordModal(toggleType = '') {
    this.setState((prevState) => ({
      isPasswordModalOpen: !prevState.isPasswordModalOpen,
      toggleType: toggleType,
      password: '',
      passwordError: null,
    }));
  }

  validatePasswordAndToggle() {
    const { password, toggleType } = this.state;
    const partnerId = localStorage.getItem('partnerId');
    const client = localStorage.getItem('client');

    const isValidPassword =
      client === 'SWISS' || client === 'POLAND'
        ? password === partnerId
        : password === 'ADI#12345';

    if (!isValidPassword) {
      this.setState({ passwordError: 'Please enter the correct password' });
      return;
    }

    if (toggleType === 'isEmailAuthorizedModel') {
      this.setState(
        (prevState) => ({
          isEmailAuthorizedModel: !prevState.isEmailAuthorizedModel,
          isEmailAuthorized: !prevState.isEmailAuthorizedModel, // Open modal when toggled on, close when toggled off
          isPasswordModalOpen: false,
        }),
        () => {
          if (this.state.isEmailAuthorizedModel) {
            window.open('/emailAuthorized', '_blank');
            // window.open(window.location.origin + "/emailAuthorized", "_blank", `width=${window.outerWidth},height=${window.outerHeight}`);
            this.setState({
              isEmailAuthorizedModel: false,
            })
          }
        }
      );
    } else if (toggleType === 'isDatModel') {
      this.setState(
        (prevState) => ({
          isDatModel: !prevState.isDatModel,
          isDatAuthorized: !prevState.isDatModel, // Open modal when toggled on, close when toggled off
          isPasswordModalOpen: false,
        }),
        () => {
          if (this.state.isDatModel) {
            window.open('/datCredentials', '_blank');
            // window.open(window.location.origin + "/datCredentials", "_blank", `width=${window.outerWidth},height=${window.outerHeight}`);
            this.setState({
              isDatModel: false,
            })
          }
        }
      );
    }
  }

  handlePasswordChange(e) {
    this.setState({ password: e.target.value, passwordError: null });
  }

  // handleRedirectExtraPage=(e)=>{
  //   this.setState({showExtraPage : e.target.checked })
  //   if(e.target.checked){
  //     setTimeout(() => {
  //       this.props.history.push('/polandExtraPage');
  //     }, 300);
  //   }
  // }

  onSubmit = async (event) => {
    const client = localStorage.getItem("client");
    const {
      alu,
      lak,
      glu,
      bodyWork,
      printed_form,
      email,
      company_name,
      website_url,
      address,
      partner_id,
      primary_contact,
      company_registration_no,
      primary_color,
      table_footer_color,
      secondary_color,
      primary_text_color,
      secondary_text_color,
      logo_image,
      PricePerHour,
      authorizer_name,
      badge_number,
      basePrice,
      drive_name,
      carDetails,
      is_email,
      showExtraPage,
      damageImageToggle,
      selectedpartnerId,
      dentShowingToggle,
      dentEditorRemoveX,
      showReplaceColumn
    } = this.state;
    this.setState({ error: null, isSpinnerToggle: true });

    event.preventDefault();

    if (
      company_name === "" &&
      website_url === "" &&
      email == "" &&
      address === "" &&
      partner_id === "" &&
      primary_contact === "" &&
      // company_registration_no === "" &&
      primary_color === "" &&
      secondary_color === "" &&
      primary_text_color === "" &&
      secondary_text_color === "" &&
      alu === "" &&
      lak === "" &&
      glu === "" &&
      bodyWork === "" &&
      printed_form === "" &&
      authorizer_name === "" &&
      badge_number === "" &&
      logo_image === "" &&
      PricePerHour === ""
    ) {
      this.setState({ error: "Please Fill Everything Up Properly" });
    } else if (email === "") {
      this.setState({ error: "Please Enter your Email address" });
    } else if (company_name === "") {
      this.setState({ error: "Please Enter your company name" });
    } else if (website_url === "") {
      this.setState({ error: "Please Enter Your Website Properly" });
    } else if (address === "") {
      this.setState({ error: "Please Enter Your Street Address" });
    } else if (partner_id === "") {
      this.setState({ error: "Something is wrong" });
    } else if (primary_contact === "") {
      this.setState({ error: "Please Enter Your Primary Contact Number" });
    } else if (!(/^((?:\+\d+)?\s*(?:\(\d+\)\s*(?:[\/–-]\s*)?)?\d+(?:\s*(?:[\s\/–-]\s*)?\d+)*)$/.test(primary_contact))) {
      this.setState({ error: "Please Enter Valid Primary Contact Number" });
    }
    // else if (company_registration_no === "") {
    //   this.setState({ error: "Please Enter Your Company Number" });
    // } 
    else if (primary_color === "") {
      this.setState({ error: "Please Select Primary Color" });
    } else if (secondary_color === "") {
      this.setState({ error: "Please Select Secondary Color" });
    } else if (primary_text_color === "") {
      this.setState({ error: "Please Select Primary Text Color" });
    } else if (secondary_text_color === "") {
      this.setState({ error: "Please Select Secondary Text Color" });
    } else if (alu === "") {
      this.setState({ error: "Please Enter the % of ALU" });
    } else if (lak === "") {
      this.setState({ error: "Please Enter the % of LAK" });
    } else if ((client == 'DNS' || localStorage.getItem("partnerId") == "28-240601") && glu === "") {
      this.setState({ error: "Please Enter the % of Glue" });
    } else if ((localStorage.getItem("partnerId") == "28-240601") && bodyWork === "") {
      this.setState({ error: "Please Enter the % of WR" });
    } else if (printed_form === "") {
      this.setState({ error: "Please Enter the % of printed_form" });
    } else if (logo_image === "") {
      this.setState({ error: "Please Select Your company logo!!" });
    } else if (PricePerHour === "") {
      this.setState({ error: "Please Enter Base Price!" });
    } else {
      this.setState({ isSpinnerToggle: true });
      const url = configuration.postFallbackDetails;
      let payload;
      if (partner_id === '12-210615') {
        if (authorizer_name === "") {
          this.setState({ error: "Please Enter Authorizer Name!" });
        } else if (badge_number === "") {
          this.setState({ error: "Please Enter Badge Number!" });
        }
        payload = {
          email,
          partner_company_name: company_name,
          website_url,
          address,
          partner_id,
          primary_contact: primary_contact.replace(/\s\s+/g, ' '),
          company_registration_no,
          primary_color,
          secondary_color,
          primary_text_color,
          secondary_text_color,
          alu,
          lak,
          glu,
          company_logo: logo_image,
          PricePerHour,
          authorizer_name,
          badge_number,
          svg_part_number: this.state.svgPartNumber == true ? 1 : 2,
          extended_view: this.state.extendedImageViewlabel == true ? 1 : 0,
          is_document_show: this.state.showRomDocument == true ? "1" : "0",
          is_default_damage_image: damageImageToggle == true ? "1" : "0",
          vin_duplicate_partner_id: selectedpartnerId,
          dent_showing : dentShowingToggle == true ? "1" : "0",
          is_remove_x : dentEditorRemoveX == true ? "1" : "0",
          is_show_replace_column : showReplaceColumn == true ? "1" : "0",
        };
      } else {
        payload = {
          email,
          partner_company_name: company_name,
          website_url,
          address,
          partner_id,
          primary_contact: primary_contact.replace(/\s\s+/g, ' '),
          company_registration_no,
          primary_color,
          secondary_color,
          primary_text_color,
          secondary_text_color,
          alu,
          lak,
          glu,
          company_logo: logo_image,
          PricePerHour,
          carDetails,
          is_email: is_email == true ? 1 : 0 || '',
          svg_part_number: this.state.svgPartNumber == true ? 1 : 2,
          extended_view: this.state.extendedImageViewlabel == true ? 1 : 0,
          is_document_show: this.state.showRomDocument == true ? "1" : "0",
          is_default_damage_image: damageImageToggle == true ? "1" : "0",
          vin_duplicate_partner_id: selectedpartnerId,
          dent_showing : dentShowingToggle == true ? "1" : "0",
          is_remove_x : dentEditorRemoveX == true ? "1" : "0",
          is_show_replace_column : showReplaceColumn == true ? "1" : "0",
          WR : bodyWork,
        };
        (['SWISS', 'FR'].includes(client)) && (payload.basePrice = basePrice) && (payload.drive_through = drive_name);
        (client === 'AUT') && (payload.printed_form = printed_form);
        (partner_id === 'TDCAG') && (payload.table_footer_color = table_footer_color) && (payload.drive_through = drive_name);
      }
      if (is_email === false || is_email === "0") {
        localStorage.setItem("isSendEmail", "no");
      } else {
        localStorage.setItem("isSendEmail", "yes");
      }

      await Axios.post(url, payload)
        .then((res) => {
          this.setState({ isSpinnerToggle: false });
          if (res.data) {
            if (client == "ROM") {
              localStorage.setItem("showDocumentExtraImage", this.state.showRomDocument == true ? 1 : 0);
            }
          }

          if (res.data.success) {
            Toast.fire({
              type: "success",
              title: res.data.message,
            });
          }
          if (res.data.validation_errors) {
            const errors = Object.values(res.data.validation_errors);
            let err_msg = "";
            errors.map((item) => {
              err_msg = err_msg + err_msg ? " | " : "" + item;
            });
            // Toast.fire({
            //   type: "error",
            //   title: res.data.message,
            // });

            // alert(err_msg);
          }
          // else {
          //   // alert(res.data.message);
          //   Toast.fire({
          //     type: "error",
          //     title: res.data.message,
          //   });
          // }
        })
        .catch((err) => {
          this.setState({ isSpinnerToggle: false });
        });
      // if (res.data.message === "success") {
      //   localStorage.setItem("partnerId", this.state.partnerId);
      //   localStorage.setItem("pdfHeader", res.data.pdfHeader);
      //   localStorage.setItem("pdfFooter", res.data.pdfFooter);
      //   localStorage.setItem("client", res.data.client);
      //   localStorage.setItem("lang", "de");
      //   this.props.history.push("/dashboard");
      //   window.location.reload();
      // } else {
      //   alert("Login Failed!,Try Again");
      // }

      // this.props.firebase
      //   .doCreateUserWithEmailAndPassword(email, passwordOne)
      //   .then((authUser) => {
      //     // Create a user in your Firebase realtime database
      //     this.props.firebase.userAuthorization(authUser.user.uid).set({
      //       college,
      //       role,
      //     });

      //     this.props.firebase.faculty(college, authUser.user.uid).set({
      //       name: fname + " " + lname,
      //       email,
      //       access_code: accesscode,
      //     });
      //   })
      //   .then(() => {
      //     this.setState({ ...INITIAL_STATE });
      //     this.props.history.push('/profile');
      //   })
      //   .catch((error) => {
      //     // if (this.state.error == null) {
      //     //   if (error.code === ERROR_CODE_ACCOUNT_EXISTS) {
      //     //     error.message = ERROR_MSG_ACCOUNT_EXISTS;
      //     //     this.setState({ error: error.message });
      //     //   } else if (error.code === ERROR_CODE_INVALID_EMAIL) {
      //     //     error.message = ERROR_MSG_INVALID_EMAIL;
      //     //     this.setState({ error: error.message });
      //     //   }
      //     // }
      //   });
    }
  };

  // termCheckboxToggleInfo = () => {
  //   this.setState({ termCheckboxToggle: !this.state.termCheckboxToggle });
  // };
  carDetailsConvertInObj = () => {
    const { carDetails } = this.state;
    const transformedCarDetails = {};
    carDetails && carDetails.forEach(detail => {
      const { CarType, priceType, price } = detail;

      if (!transformedCarDetails[`price${priceType}`]) {
        transformedCarDetails[`price${priceType}`] = {};
      }

      transformedCarDetails[`price${priceType}`][CarType] = price;
    });
    return transformedCarDetails
  }

  handleSelectChange = (selectedOptions) => {
    const selectedpartnerId = selectedOptions.map((option) => option.value);
    this.setState({ partnerIdOptions: selectedOptions || [], partnerId: '', selectedpartnerId });
  };

  handleInputChange = (inputValue) => {
    // Update inputValue state
    this.setState({ partnerId: inputValue });

    // Trigger filtering manually when input value changes
    if (inputValue.length >= 3) {
      this.setState({ showOptions: true });
    } else {
      this.setState({ showOptions: false });
    }
  };

  filterOptions = (option, inputValue) => {
    // Show options only if inputValue length is 3 or more
    return inputValue.length >= 3
      ? option.label.toLowerCase().includes(inputValue.toLowerCase())
      : false;
  };

  render() {
    const client = localStorage.getItem('client')
    const {
      email,
      company_name,
      website_url,
      address,
      partner_id,
      primary_contact,
      company_registration_no,
      error,
      primary_color,
      secondary_color,
      primary_text_color,
      secondary_text_color,
      table_footer_color,
      alu,
      lak,
      glu,
      bodyWork,
      printed_form,
      logo_image,
      PricePerHour,
      authorizer_name,
      badge_number,
      basePrice,
      is_email,
      svgPartNumber,
      extendedImageViewlabel,
      showRomDocument,
      showExtraPage,
      is_email_authorized,
      is_dat,
      isEmailAuthorizedModel,
      isDatModel,
      isPasswordModalOpen,
      password,
      passwordError,
      partnerIdOptions,
      partnerId,
      clientBasedOptions,
      damageImageToggle,
      showDamageToggle,
      dentShowingToggle,
      dentEditorRemoveX,
      showReplaceColumn,
      is_vin_duplicate
    } = this.state;

    let priceObj = this.carDetailsConvertInObj();
    return (
      <div className="row justify-content-center">
        <div className="col-lg-7 col-md-12 col-sm-12">
          <div className="customer_profile">
            <form
              onSubmit={this.onSubmit}
              className="FacSignupForm form"
              autoComplete="off"
            >
              <div
                style={{
                  width: "100%",
                  display: "grid",
                  placeItems: "center",
                  marginTop: 10,
                }}
                className={"company_logo"}
              >
                <label htmlFor="getFile">
                  <div
                    ref={(comp) => {
                      this.logo_img_ref = comp;
                    }}
                  >
                    <p
                      style={{
                        fontSize: 16,
                        color: "#454545",
                        fontWeight: "bold",
                        margin: 0,
                        padding: "0 10px",
                      }}
                    >
                      {this.lang("companyLogo")}
                    </p>
                  </div>
                </label>
                <input
                  id="getFile"
                  style={{ display: "none" }}
                  name="logo_image"
                  type="file"
                  accept=".jpg,.jpeg,.png,.bmp"
                  onChange={(e) => {
                    this.onLogoImageSelect(e);
                  }}
                />
              </div>
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="row justify-content-center">
                    <div className="col-lg-8 col-md-10 col-sm-12">
                      <div className="group full-name w-100 m-0">
                        <input
                          type="text"
                          name="company_name"
                          className="profile_input"
                          value={company_name}
                          onChange={this.onChange}
                        />
                        <label
                          className={
                            company_name !== "" ? "placeholder above" : "placeholder"
                          }
                        >
                          {this.lang("companyName")}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <input
                    autoComplete="nope"
                    type="email"
                    name="email"
                    className="profile_input"
                    value={email}
                    onChange={this.onChange}
                  />
                  <label
                    className={email !== "" ? "placeholder above" : "placeholder"}
                  >
                    {this.lang("Email Address")}
                  </label>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <input
                    placeholder="https://example.com"
                    type="text"
                    // type="url"
                    name="website_url"
                    className="profile_input"
                    value={website_url}
                    onChange={this.onChange}
                  />
                  <label
                    // className={website_url !== "" ? "placeholder above" : "placeholder"}
                    className={"placeholder above"}
                  >
                    {this.lang("Website")}
                  </label>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <input
                    maxLength={60}
                    type="text"
                    name="address"
                    className="profile_input"
                    value={address}
                    onChange={this.onChange}
                  />
                  <label
                    className={address !== "" ? "placeholder above" : "placeholder"}
                  >
                    {this.lang("Address")}
                  </label>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <input
                    type="text"
                    name="partner_id"
                    className="profile_input"
                    placeholder={partner_id}
                    // style={{backgroundColor:'white'}}
                    disabled
                  />
                  <label
                    className={
                      partner_id !== "" ? "placeholder above" : "placeholder"
                    }
                  >
                    {this.lang("Partner ID")}
                  </label>
                </div>

                <div className="col-lg-6 col-md-12 col-sm-12">
                  <input
                    autoComplete="nope"
                    type="text"
                    name="primary_contact"
                    className="profile_input"
                    value={primary_contact}
                    onChange={this.onChange}
                  />
                  <label
                    className={
                      primary_contact !== "" ? "placeholder above" : "placeholder"
                    }
                  >
                    {this.lang('contactNumber')}
                  </label>
                </div>

                <div className="col-lg-6 col-md-12 col-sm-12">
                  <input
                    autoComplete="nope"
                    type="text"
                    name="company_registration_no"
                    className="profile_input"
                    value={company_registration_no}
                    onChange={(e) => {
                      e.target.value = e.target.value.toUpperCase();
                      this.onChange(e);
                    }}
                  />
                  <label
                    className={
                      company_registration_no !== ""
                        ? "placeholder above"
                        : "placeholder"
                    }
                  >
                    {this.lang("profile Registration No.")}
                  </label>
                </div>


                <div className="col-lg-6 col-md-12 col-sm-12">
                  <input
                    autoComplete="nope"
                    type="number"
                    max={100}
                    min={-100}
                    name="alu"
                    className="profile_input"
                    value={alu}
                    onChange={this.onChange}
                  />
                  <label
                    className={alu !== "" ? "placeholder above" : "placeholder"}
                  >
                    ALU (%)
                  </label>
                </div>

                <div className="col-lg-6 col-md-12 col-sm-12">
                  <input
                    autoComplete="nope"
                    type="number"
                    max={100}
                    min={-100}
                    name="lak"
                    className="profile_input"
                    value={lak}
                    onChange={this.onChange}
                  />
                  <label
                    className={lak !== "" ? "placeholder above" : "placeholder"}
                  >
                    LAK (%)
                  </label>
                </div>
                {(localStorage.getItem("client") == 'DNS' || localStorage.getItem("partnerId") == "28-240601") && 
                  <>
                    <div className="col-lg-6 col-md-12 col-sm-12">
                      <input
                        autoComplete="nope"
                        type="number"
                        max={100}
                        min={-100}
                        name="glu"
                        className="profile_input"
                        value={glu}
                        onChange={this.onChange}
                      />
                      <label
                        className={glu !== "" ? "placeholder above" : "placeholder"}
                      >
                        Glue (%)
                      </label>
                    </div>
                  </>
                }
                {(localStorage.getItem("partnerId") == "28-240601") && 
                  <>
                    <div className="col-lg-6 col-md-12 col-sm-12">
                      <input
                        autoComplete="nope"
                        type="number"
                        max={100}
                        min={-100}
                        name="bodyWork"
                        className="profile_input"
                        value={bodyWork}
                        onChange={this.onChange}
                      />
                      <label
                        className={bodyWork !== "" ? "placeholder above" : "placeholder"}
                      >
                        WR (%)
                      </label>
                    </div>
                  </>
                }
                {partner_id === "12-210615" &&
                  <>
                    <div className="col-lg-6 col-md-12 col-sm-12">
                      <input
                        autoComplete="nope"
                        type="text"
                        name="authorizer_name"
                        className="profile_input"
                        value={authorizer_name}
                        onChange={this.onChange}
                      />
                      <label
                        className={authorizer_name !== "" ? "placeholder above" : "placeholder"}
                      >
                        Authorizer Name
                      </label>
                    </div>

                    <div className="col-lg-6 col-md-12 col-sm-12">
                      <input
                        autoComplete="nope"
                        type="text"
                        name="badge_number"
                        className="profile_input"
                        value={badge_number}
                        onChange={this.onChange}
                      />
                      <label
                        className={badge_number !== "" ? "placeholder above" : "placeholder"}
                      >
                        Badge Number
                      </label>
                    </div>
                  </>
                }
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <input
                    autoComplete="nope"
                    type="number"
                    min={0}
                    name="PricePerHour"
                    className="profile_input"
                    value={PricePerHour}
                    onChange={this.onChange}
                  />
                  <label
                    className={PricePerHour !== "" ? "placeholder above" : "placeholder"}
                  >
                    {client === 'SWISS' ? this.lang("Price/HrPress") : this.lang("Price/hr")}
                  </label>
                </div>
                {partner_id === "demo-at" &&
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <input
                      autoComplete="nope"
                      type="number"
                      max={100}
                      min={-100}
                      name="printed_form"
                      className="profile_input"
                      value={printed_form}
                      onChange={this.onChange}
                    />
                    <label
                      className={lak !== "" ? "placeholder above" : "placeholder"}
                    >
                      Printed Form (%)
                    </label>
                  </div>
                }
                {client === 'SWISS' &&
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <input
                      autoComplete="nope"
                      type="number"
                      min={0}
                      name="basePrice"
                      className="profile_input"
                      value={basePrice}
                      onChange={this.onChange}
                    />
                    <label
                      className={basePrice !== "" ? "placeholder above" : "placeholder"}
                    >
                      {this.lang("Price/hrDe-&montage")}
                    </label>
                  </div>}
                {client === 'FR' &&
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <input
                      autoComplete="nope"
                      type="number"
                      min={0}
                      name="basePrice"
                      className="profile_input"
                      value={basePrice}
                      onChange={this.onChange}
                    />
                    <label
                      className={basePrice !== "" ? "placeholder above" : "placeholder"}
                    >
                      {this.lang("Price/hr")}-2
                    </label>
                  </div>}
                <div className="col-lg-12">
                  <div className="row theme-color-wrapper-profile">
                    <div className="col-lg-6 col-md-12 col-sm-12">
                      <label className="d-block text-left mb-2">
                        {this.lang("Report color for header")}
                      </label>
                      <label
                        htmlFor="getPrimaryColor"
                        className="profile_input"
                        style={{ position: "relative" }}
                      >

                        <div className="profile_input" style={{ border: "none" }}>
                          <label className={"placeholder placeholder-color-picker"}>
                            {this.lang("Primary Color")} - {`${primary_color}`.toUpperCase()}
                          </label>
                          <div
                            className={"color_picker"}
                            style={{ backgroundColor: `${primary_color}` }}
                          />
                        </div>
                      </label>
                      <input
                        value={primary_color}
                        style={{ visibility: "hidden", height: 0, width: 0 }}
                        type="color"
                        id="getPrimaryColor"
                        name="primary_color"
                        onChange={this.onChange}
                      />
                    </div>

                    <div className="secondaryColor col-lg-6 col-md-12 col-sm-12">
                      <label className="d-block text-left mb-2">
                        {this.lang("Report color for footer")}
                      </label>
                      <label
                        htmlFor="getSecondaryColor"
                        className="profile_input"
                        style={{ position: "relative" }}
                      >
                        <div className="profile_input" style={{ border: "none" }}>
                          <label className={"placeholder placeholder-color-picker"}>
                            {this.lang("Secondary Color")} - {`${secondary_color}`.toUpperCase()}
                          </label>
                          <div
                            className={"color_picker"}
                            style={{ backgroundColor: `${secondary_color}` }}
                          />
                        </div>
                      </label>
                      <input
                        value={secondary_color}
                        style={{ visibility: "hidden", height: 0, width: 0 }}
                        type="color"
                        id="getSecondaryColor"
                        name="secondary_color"
                        onChange={this.onChange}
                      />
                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12 mt-1">
                      <label className="d-block text-left mb-2">
                        {this.lang("Report text color for header")}
                      </label>
                      <label
                        htmlFor="getPrimaryTextColor"
                        className="profile_input"
                        style={{ position: "relative" }}
                      >
                        <div className="profile_input" style={{ border: "none" }}>
                          <label className={"placeholder placeholder-color-picker"}>
                            {this.lang("Primary Text Color")} - {`${primary_text_color}`.toUpperCase()}
                          </label>
                          <div
                            className={"color_picker"}
                            style={{ backgroundColor: `${primary_text_color}` }}
                          />
                        </div>
                      </label>
                      <input
                        value={primary_text_color}
                        style={{ visibility: "hidden", height: 0, width: 0 }}
                        type="color"
                        id="getPrimaryTextColor"
                        name="primary_text_color"
                        onChange={this.onChange}
                      />
                    </div>

                    <div className="col-lg-6 col-md-12 col-sm-12 mt-1 secondaryColor">
                      <label className="d-block text-left mb-2">
                        {this.lang("Report text color for footer")}
                      </label>
                      <label
                        htmlFor="getSecondaryTextColor"
                        className="profile_input"
                        style={{ position: "relative" }}
                      >
                        <div className="profile_input" style={{ border: "none" }}>
                          <label className={"placeholder placeholder-color-picker"}>
                            {this.lang("Secondary Text Color")} - {`${secondary_text_color}`.toUpperCase()}
                          </label>
                          <div
                            className={"color_picker"}
                            style={{ backgroundColor: `${secondary_text_color}` }}
                          />
                        </div>
                      </label>
                      <input
                        value={secondary_text_color}
                        style={{ visibility: "hidden", height: 0, width: 0 }}
                        type="color"
                        id="getSecondaryTextColor"
                        name="secondary_text_color"
                        onChange={this.onChange}
                      />
                    </div>
                  </div>
                </div>


                {client === 'SWISS' &&
                  <>
                    {partner_id === 'TDCAG' &&
                      <div className="col-lg-12 col-md-12 col-sm-12 p-0">
                        <div className="row p-0">
                          <div className="col-lg-6 col-md-12 col-sm-12 mt-2 secondaryColor">
                            <label
                              htmlFor="gettablefootercolor"
                              className="profile_input mb-1"
                              style={{ position: "relative" }}
                            >
                              <div className="profile_input mb-0" style={{ border: "none" }}>
                                <label className={"placeholder placeholder-color-picker"}>
                                  Table Footer Color - {`${table_footer_color}`.toUpperCase()}
                                </label>
                                <div
                                  className={"color_picker"}
                                  style={{ backgroundColor: `${table_footer_color}` }}
                                />
                              </div>
                            </label>
                            <input
                              value={table_footer_color}
                              style={{ visibility: "hidden", height: 0, width: 0 }}
                              type="color"
                              id="gettablefootercolor"
                              name="table_footer_color"
                              onChange={this.onChange}
                            />
                          </div>
                        </div>
                      </div>
                    }

                    {/* Drive-In / Drive-Through radio buttons */}
                    {/* <div className="col-lg-6 col-md-12 col-sm-12 mt-2">
                      <div className="main_email_container p-0">
                        <div className="row profile_input d-flex align-item-center">
                          <div className="col-6 form-check d-flex align-item-center p-0">
                            <input
                              type="radio"
                              name="drive_name"
                              value="1"
                              // checked
                              onChange={this.onChange}
                              checked={this.state.drive_name == "1"}
                              className="mr-1"
                            />
                            <Label className="ml-2">{this.lang("Drive-In")}</Label>
                          </div>
                          <div className="col-6 form-check d-flex align-item-center p-0">
                            <input
                              type="radio"
                              name="drive_name"
                              value="0"
                              className="mr-1"
                              onChange={this.onChange}
                              checked={this.state.drive_name == "0"}
                            />
                            <Label className="ml-2">{this.lang("Drive-Through")}</Label>
                          </div>
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="col-lg-6 col-md-12 col-sm-12 mt-2">
                      <div className="main_email_container p-0">
                        <div className="row profile_input d-flex align-item-center">
                          <div className="col-6 form-check d-flex align-item-center p-0">
                            <input
                              type="radio"
                              name="svgType"
                              value="1"
                              checked={this.state.svgPartNumber === "1"}
                              onChange={this.handleSvgPartChange}
                            />
                            <Label className="ml-2"> {this.lang("93 Part SVG")} </Label>
                          </div>
                          <div className="col-6 form-check d-flex align-item-center p-0">
                            <input
                              type="radio"
                              name="svgType"
                              value="2"
                              checked={this.state.svgPartNumber === "2"}
                              onChange={this.handleSvgPartChange}
                            />
                            <Label className="ml-2">{this.lang("13 Part SVG")}</Label>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </>
                }
                {
                  client === "CANADA" &&
                  <div className="card_price_wrapper col-lg-12 col-md-12 col-sm-12 mb-3 mt-2">
                        <div className="bg_price_wrapper">
                          <div className="group text-left">
                          </div>
                          <div className="col-lg-12 col-md-12 col-sm-12">
                            <input
                              autocomplete="nope"
                              type="number"
                              className="profile_input"
                              onChange={(e) => this.handlePriceChange(e, 3)}
                              defaultValue='0.00'
                              name="normal"
                              value={priceObj && priceObj.price3 && priceObj.price3.normal}
                            />
                            <label className="placeholder above">
                              {this.lang("normal")}
                            </label>
                          </div>

                          <div className="col-lg-12 col-md-12 col-sm-12">
                            <input
                              autocomplete="nope"
                              type="number"
                              className="profile_input"
                              onChange={(e) => this.handlePriceChange(e, 3)}
                              defaultValue='0.00'
                              name="van"
                              value={priceObj && priceObj.price3 && priceObj.price3.van}
                            />
                            <label className="placeholder above">
                              {this.lang("van")}
                            </label>
                          </div>
                          <div className="col-lg-12 col-md-12 col-sm-12">
                            <input
                              autocomplete="nope"
                              type="number"
                              className="profile_input"
                              onChange={(e) => this.handlePriceChange(e, 3)}
                              defaultValue='0.00'
                              name="suv"
                              value={priceObj && priceObj.price3 && priceObj.price3.suv}
                            />
                            <label className="placeholder above">
                              {this.lang("suv")}
                            </label>
                          </div>

                          <div className="col-lg-12 col-md-12 col-sm-12">
                            <input
                              autocomplete="nope"
                              type="number"
                              value={priceObj && priceObj.price3 && priceObj.price3.extendedCabTruck}
                              className="profile_input"
                              onChange={(e) => this.handlePriceChange(e, 3)}
                              defaultValue='0.00'
                              name="extendedCabTruck"
                            />
                            <label className="placeholder above">
                              {this.lang("extendedCabTruck")}
                            </label>
                          </div>
                        </div>
                      </div>
                }

                {/* French Client Input Price Design:: START */}
                {client === 'FR' &&
                  <div className="col-lg-12">
                    <div className="row p-0">
                      {/* First Report :: START */}
                      <div className="card_price_wrapper col-lg-6 col-md-12 col-sm-12 mb-3 mt-2">
                        <div className="bg_price_wrapper">
                          <div className="group text-left">
                            <h6>{this.lang("Price")} - 1</h6>
                          </div>
                          <div className="col-lg-12 col-md-12 col-sm-12">
                            <input
                              autocomplete="nope"
                              type="number"
                              className="profile_input"
                              onChange={(e) => this.handlePriceChange(e, 1)}
                              defaultValue='0.00'
                              name="smallCityCar"
                              value={priceObj && priceObj.price1 && priceObj.price1.smallCityCar}
                            />
                            <label className="placeholder above">
                              {this.lang("Small, Citycar")}
                            </label>
                          </div>

                          <div className="col-lg-12 col-md-12 col-sm-12">
                            <input
                              autocomplete="nope"
                              type="number"
                              className="profile_input"
                              onChange={(e) => this.handlePriceChange(e, 1)}
                              defaultValue='0.00'
                              name="compactFamily"
                              value={priceObj && priceObj.price1 && priceObj.price1.compactFamily}
                            />
                            <label className="placeholder above">
                              {this.lang("Compact,Family")}
                            </label>
                          </div>
                          <div className="col-lg-12 col-md-12 col-sm-12">
                            <input
                              autocomplete="nope"
                              type="number"
                              className="profile_input"
                              onChange={(e) => this.handlePriceChange(e, 1)}
                              defaultValue='0.00'
                              name="luxuryCar"
                              value={priceObj && priceObj.price1 && priceObj.price1.luxuryCar}
                            />
                            <label className="placeholder above">
                              {this.lang("Luxury, 4 X 4")}
                            </label>
                          </div>

                          <div className="col-lg-12 col-md-12 col-sm-12">
                            <input
                              autocomplete="nope"
                              type="number"
                              value={priceObj && priceObj.price1 && priceObj.price1.suv}
                              className="profile_input"
                              onChange={(e) => this.handlePriceChange(e, 1)}
                              defaultValue='0.00'
                              name="suv"
                            />
                            <label className="placeholder above">
                              {this.lang("SUV")}
                            </label>
                          </div>
                        </div>
                      </div>
                      {/*First Report :: END */} {/* Second Report :: START */}
                      {
                        partner_id !== "28-240601" &&
                      <div className="card_price_wrapper col-lg-6 col-md-12 col-sm-12 mb-3 mt-2">
                        <div className="bg_price_wrapper">
                          <div className="text-left">
                            <div className="group text-left">
                              <h6>{this.lang("Price")} - 2</h6>
                            </div>
                          </div>
                          <div className="col-lg-12 col-md-12 col-sm-12">
                            <input
                              autocomplete="nope"
                              type="number"
                              className="profile_input"
                              onChange={(e) => this.handlePriceChange(e, 2)}
                              defaultValue='0.00'
                              name="smallCityCar"
                              value={priceObj && priceObj.price2 && priceObj.price2.smallCityCar}
                            />
                            <label className="placeholder above">
                              {this.lang("Small, Citycar")}
                            </label>
                          </div>

                          <div className="col-lg-12 col-md-12 col-sm-12">
                            <input
                              autocomplete="nope"
                              type="number"
                              className="profile_input"
                              onChange={(e) => this.handlePriceChange(e, 2)}
                              defaultValue='0.00'
                              name="compactFamily"
                              value={priceObj && priceObj.price2 && priceObj.price2.compactFamily}
                            />
                            <label className="placeholder above">
                              {this.lang("Compact,Family")}
                            </label>
                          </div>
                          <div className="col-lg-12 col-md-12 col-sm-12">
                            <input
                              autocomplete="nope"
                              type="number"
                              className="profile_input"
                              onChange={(e) => this.handlePriceChange(e, 2)}
                              defaultValue='0.00'
                              name="luxuryCar"
                              value={priceObj && priceObj.price2 && priceObj.price2.luxuryCar}
                            />
                            <label className="placeholder above">
                              {this.lang("Luxury, 4 X 4")}
                            </label>
                          </div>

                          <div className="col-lg-12 col-md-12 col-sm-12">
                            <input
                              autocomplete="nope"
                              type="number"
                              className="profile_input"
                              onChange={(e) => this.handlePriceChange(e, 2)}
                              defaultValue='0.00'
                              name="suv"
                              value={priceObj && priceObj.price2 && priceObj.price2.suv}
                            />
                            <label className="placeholder above">
                              {this.lang("SUV")}
                            </label>
                          </div>
                        </div>
                      </div>
                  } 
                      {/* Second Report :: START */}
                    </div>
                  </div>
                }
                {
                  is_vin_duplicate &&
                  <div className="col-lg-12">
                  <div className="row p-0">
                    {/* First Report :: START */}
                    <div className="card_price_wrapper col-lg-6 col-md-12 col-sm-12 mb-3 mt-2">
                      <div className="bg_price_wrapper pt-2 pb-2">
                        <div className="col-lg-12 col-md-12 col-sm-12 parentid_dropdown">
                          <div className="mb-3 form-group">
                            <label htmlFor="parentPartnerIdInput" className="form-label text-left w-100 mb-1">
                              {this.lang("Partner ID")} <span style={{fontSize:"10px"}}>(For duplicate vin)</span>
                            </label>
                            <ReactSelect
                              className="custom_input"
                              closeMenuOnSelect={false}
                              placeholder=""
                              isMulti 
                              options={this.state.clientBasedOptions}
                              onChange={this.handleSelectChange}
                              value={this.state.partnerIdOptions}
                              inputValue={this.state.partnerId}
                              onInputChange={this.handleInputChange}
                              filterOption={this.filterOptions}
                              menuIsOpen={this.state.showOptions}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/*First Report :: END */}
                  </div>
                </div>
                }
               

                {/* With Email / Without Email radio buttons */}

                <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mt-2">
                  <div className="profile_input p-0 pl-2">
                    <div className="main_switch_wrapper profile_toggle">
                      <label className="form-check-label">
                        {this.lang("E-mail with Image")}
                      </label>
                      <label className="switch">
                        <input
                          className="switch-input"
                          type="checkbox"
                          name="is_email"
                          value={is_email}
                          checked={is_email}
                          onClick={(e) => this.handleChangeEmail(e)}
                        />
                        <span className="switch-label" data-on={this.lang("Yes")} data-off={this.lang("No")}></span>
                        <span className="switch-handle"></span>
                      </label>
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mt-2">
                  <div className="profile_input p-0 pl-2">
                    <div className="main_switch_wrapper profile_toggle">
                      <label className="form-check-label">
                        {this.lang("SVG Type")}
                      </label>
                      <label className="switch">
                        <input
                          className="switch-input"
                          type="checkbox"
                          name="svgType"
                          value={svgPartNumber}
                          checked={svgPartNumber}
                          onClick={(e) => this.handleSvgPartChange(e)}
                        />
                        <span className="switch-label" data-on={this.lang("94")} data-off={this.lang("13")}></span>
                        <span className="switch-handle"></span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mt-2">
                  <div className="profile_input p-0 pl-2">
                    <div className="main_switch_wrapper profile_toggle">
                      <label className="form-check-label">
                        {this.lang("Extended Image View")}
                      </label>
                      <label className="switch">
                        <input
                          className="switch-input"
                          type="checkbox"
                          name="svgType"
                          value={extendedImageViewlabel}
                          checked={extendedImageViewlabel}
                          onClick={(e) => this.handleExtendImageView(e)}
                        />
                        <span className="switch-label" data-on={this.lang("Yes")} data-off={this.lang("No")}></span>
                        <span className="switch-handle"></span>
                      </label>
                    </div>
                  </div>
                </div>
                {
                  showDamageToggle &&
                  <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mt-2">
                    <div className="profile_input p-0 pl-2">
                      <div className="main_switch_wrapper profile_toggle">
                        <label className="form-check-label">
                          {this.lang("ShowDamageImage")}
                        </label>
                        <label className="switch">
                          <input
                            className="switch-input"
                            type="checkbox"
                            name="svgType"
                            value={damageImageToggle}
                            checked={damageImageToggle}
                            onClick={(e) => this.handleDamageToggle(e)}
                          />
                          <span className="switch-label" data-on={this.lang("Yes")} data-off={this.lang("No")}></span>
                          <span className="switch-handle"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                }
                {
                  <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mt-2">
                    <div className="profile_input p-0 pl-2">
                      <div className="main_switch_wrapper profile_toggle">
                        <label className="form-check-label">
                          {this.lang("ShowDentCount")}
                        </label>
                        <label className="switch">
                          <input
                            className="switch-input"
                            type="checkbox"
                            name="svgType"
                            value={dentShowingToggle}
                            checked={dentShowingToggle}
                            onClick={(e) => this.handleDentShowingToggle(e)}
                          />
                          <span className="switch-label" data-on={this.lang("Yes")} data-off={this.lang("No")}></span>
                          <span className="switch-handle"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                }
                {client === "POLAND" && 
                  <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mt-2">
                    <div className="profile_input p-0 pl-2">
                      <div className="main_switch_wrapper profile_toggle">
                        <label className="form-check-label">
                          {this.lang("DentEditorRemoveX")}
                        </label>
                        <label className="switch">
                          <input
                            className="switch-input"
                            type="checkbox"
                            name="svgType"
                            value={dentEditorRemoveX}
                            checked={dentEditorRemoveX}
                            onClick={(e) => this.handleDentRemovexToggle(e)}
                          />
                          <span className="switch-label" data-on={this.lang("Yes")} data-off={this.lang("No")}></span>
                          <span className="switch-handle"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                }
                {(client === "POLAND" || client === "FR") && 
                  <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mt-2">
                    <div className="profile_input p-0 pl-2">
                      <div className="main_switch_wrapper profile_toggle">
                        <label className="form-check-label">
                          {this.lang("showReplaceColumn")}
                        </label>
                        <label className="switch">
                          <input
                            className="switch-input"
                            type="checkbox"
                            name="svgType"
                            value={showReplaceColumn}
                            checked={showReplaceColumn}
                            onClick={(e) => this.handleShowReplaceColumnToggle(e)}
                          />
                          <span className="switch-label" data-on={this.lang("Yes")} data-off={this.lang("No")}></span>
                          <span className="switch-handle"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                }

                {/* 
                {is_email_authorized && 
                <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mt-2">
                  <div className="profile_input p-0 pl-2">
                    <div className="main_switch_wrapper profile_toggle">
                      <label className="form-check-label">
                        {this.lang("Email Authorize")}
                      </label>
                      <label className="switch">
                        <input
                          className="switch-input"
                          type="checkbox"
                          name="svgType"
                          value={isEmailAuthorizedModel}
                          checked={isEmailAuthorizedModel}
                          onClick={(e) => this.handleEmailAuthorize(e)}
                        />
                        <span className="switch-label" data-on={this.lang("Yes")} data-off={this.lang("No")}></span>
                        <span className="switch-handle"></span>
                      </label>
                    </div>
                  </div>
                </div>
                }

              {is_dat &&
                <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mt-2">
                  <div className="profile_input p-0 pl-2">
                    <div className="main_switch_wrapper profile_toggle">
                      <label className="form-check-label">
                        {this.lang("DAT Credentials")}
                      </label>
                      <label className="switch">
                        <input
                          className="switch-input"
                          type="checkbox"
                          name="svgType"
                          value={isDatModel}
                          checked={isDatModel}
                          onClick={(e) => this.handleDATCredentials(e)}
                        />
                        <span className="switch-label" data-on={this.lang("Yes")} data-off={this.lang("No")}></span>
                        <span className="switch-handle"></span>
                      </label>
                    </div>
                  </div>
                </div>
               } */}
                {/* 
                {is_email_authorized && (
                  <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mt-2">
                    <div className="profile_input p-0 pl-2">
                      <div className="main_switch_wrapper profile_toggle">
                        <label className="form-check-label">
                          {this.lang('Email Authorize')}
                        </label>
                        <label className="switch">
                          <input
                            className="switch-input"
                            type="checkbox"
                            name="emailAuthorize"
                            value={isEmailAuthorizedModel}
                            checked={isEmailAuthorizedModel}
                            onClick={() => this.togglePasswordModal('isEmailAuthorizedModel')}
                          />
                          <span className="switch-label" data-on={this.lang('Yes')} data-off={this.lang('No')}></span>
                          <span className="switch-handle"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                )}

                {is_dat && (
                  <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mt-2">
                    <div className="profile_input p-0 pl-2">
                      <div className="main_switch_wrapper profile_toggle">
                        <label className="form-check-label">
                          {this.lang('DAT Credentials')}
                        </label>
                        <label className="switch">
                          <input
                            className="switch-input"
                            type="checkbox"
                            name="datCredentials"
                            value={isDatModel}
                            checked={isDatModel}
                            onClick={() => this.togglePasswordModal('isDatModel')}
                          />
                          <span className="switch-label" data-on={this.lang('Yes')} data-off={this.lang('No')}></span>
                          <span className="switch-handle"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                )} */}

                {/* {this.renderPasswordModal()} */}


                {/* {client == "POLAND" && <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mt-2">
                  <div className="profile_input p-0 pl-2">
                    <div className="main_switch_wrapper profile_toggle">
                      <label className="form-check-label">
                        {this.lang("Extra Page")}
                      </label>
                      <label className="switch">
                        <input
                          className="switch-input"
                          type="checkbox"
                          name="showRomDocument"
                          value={showExtraPage}
                          checked={showExtraPage}
                          onClick={(e) => this.handleRedirectExtraPage(e)}
                        />
                        <span className="switch-label" data-on={this.lang("Yes")} data-off={this.lang("No")}></span>
                        <span className="switch-handle"></span>
                      </label>
                    </div>
                  </div>
                </div>}  */}
                {client == "ROM" && <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mt-2">
                  <div className="profile_input p-0 pl-2">
                    <div className="main_switch_wrapper profile_toggle">
                      <label className="form-check-label">
                        {this.lang("Documents Page")}
                      </label>
                      <label className="switch">
                        <input
                          className="switch-input"
                          type="checkbox"
                          name="showRomDocument"
                          value={showRomDocument}
                          checked={showRomDocument}
                          onClick={(e) => this.handleRomDocumentShow(e)}
                        />
                        <span className="switch-label" data-on={this.lang("Yes")} data-off={this.lang("No")}></span>
                        <span className="switch-handle"></span>
                      </label>
                    </div>
                  </div>
                </div>}

                {/* <div className="col-lg-6 col-md-12 col-sm-12 mt-2">
                  <div className="main_email_container p-0">
                    <div className="row profile_input d-flex align-item-center">
                      <div className="col-6 form-check d-flex align-item-center">
                        <input className="form-check-input" type="radio" name="is_email" id="withEmail" checked={is_email === '1'} value={"1"} onChange={this.onChange} />
                        <label className="form-check-label" for="withEmail">
                          {this.lang("With E-mail")}
                        </label>
                      </div>
                      <div className="col-6 form-check d-flex align-item-center">
                        <input className="form-check-input" type="radio" name="is_email" id="withoutEmail" checked={is_email === '0'} value={"0"} onChange={this.onChange} />
                        <label className="form-check-label" for="withoutEmail">
                          {this.lang("Without E-mail")}
                        </label>
                      </div>
                    </div>
                  </div>
                </div> */}

                {/* 93 SVG / 14 Parts SVG radio buttons */}
                {/* {client !== "SWISS" ?
                  <div className="col-lg-6 col-md-12 col-sm-12 mt-2">
                    <div className="main_email_container p-0">
                      <div className="row profile_input d-flex align-item-center">
                        <div className="col-6 form-check d-flex align-item-center p-0">
                          <input
                            type="radio"
                            name="svgType"
                            value="1"
                            checked={this.state.svgPartNumber === "1"}
                            onChange={this.handleSvgPartChange}
                          />
                          <Label className="ml-2"> {this.lang("93 Part SVG")} </Label>
                        </div>
                        <div className="col-6 form-check d-flex align-item-center p-0">
                          <input
                            type="radio"
                            name="svgType"
                            value="2"
                            checked={this.state.svgPartNumber === "2"}
                            onChange={this.handleSvgPartChange}
                          />
                          <Label className="ml-2">{this.lang("13 Part SVG")}</Label>
                        </div>
                      </div>
                    </div>
                  </div>
                  : ''
                } */}

                <button type="submit" name="submit" className="SubmitBut">
                  {this.lang("Submit")}
                </button>

                {this.state.isSpinnerToggle && error === null ? (
                  <div style={{ marginBottom: `10px`, marginTop: "-10px" }}>
                    <Spinner />
                  </div>
                ) : null}

                <div className="error-text">
                  {error !== null ? (
                    <p style={{ color: `#ff0000` }}>*{error}*</p>
                  ) : null}
                </div>
              </div>
            </form>
          </div>
        </div>
        <Modal
          isOpen={isPasswordModalOpen}
          className="password_modal"
          backdrop="static"
          toggle={this.togglePasswordModal}
        >
          <ModalHeader className="align-items-center d-flex">
            {this.lang('Enter Password')}
            {/* <i className="fa fa-close" onClick={this.togglePasswordModal}></i> */}
          </ModalHeader>

          <ModalBody>
            {/* <p className="swal-custome-text">
              {this.lang('Provide password to proceed.')}
            </p> */}
            <div className="form-group">
              <label className="mb-1">{this.lang('Password')}</label>
              <input
                className="form-control"
                type="password"
                value={password}
                onChange={this.handlePasswordChange}
              />
              {passwordError && (
                <div className="error" style={{ color: 'red' }}>
                  {passwordError}
                </div>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              className="btn btn-md p-2 mr-2"
              onClick={this.togglePasswordModal}
            >
              {this.lang('Cancel')}
            </Button>
            <Button
              color="primary"
              className="btn btn-md p-2"
              onClick={this.validatePasswordAndToggle}
            >
              {this.lang('Confirm')}
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = (props, state) => {
  return {
    allPartnerId: props.allPartnerId,
  };
};
const mapDispatchtoProps = (dispatch) => ({
  toggleDamageImages: (show) => dispatch(toggleDamageImages(show)),
});
export default compose(
  connect(mapStateToProps, mapDispatchtoProps),
  withRouter
)(Profile);